import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { TOPCLIENTS } from 'src/app/helpers/helperResources';
import { CurrencyService } from 'src/app/services/currency.service';
import { DealsService } from 'src/app/services/deals.service';
import { GeneralService } from 'src/app/services/general.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-top-clients',
  templateUrl: './top-clients.component.html',
  styleUrls: ['./top-clients.component.css']
})
export class TopClientsComponent implements OnInit {

  dataTable = {
    dataChangedObs: new BehaviorSubject(null),

    heads: [
      { title: "Client Name", key: "clientName" },
      { title: "Total Amount", key: "value", pipe: "currency" },
    ],
    options: {
      datePipe: {},
      bulkActions: [],
    },
  };
  loadingChart = false;
  heads = [
    { title: "Client Name", key: "clientName" },
    { title: "Total Count", key: "value" },
  ];
  viewType = 'invoice';
  dataSource;
  baseCurrency;
  format = 'amount';
  selectedUserDetails;
  userId;

  constructor(private invoiceServ: InvoiceService,
    private gs: GeneralService,
    private dealsServ: DealsService,
    private selectedUsersServ: PerformanceReportService,
    private currencyServ: CurrencyService, private store: Store<AppState>,
  ) {
    this.store.select('userInfo').subscribe(info => {
      this.userId = info.user.id;
    });
    this.currencyServ.org_currencies.subscribe((org_currencies: any) => {
      this.baseCurrency = org_currencies.base_currency
    });
  }

  ngOnInit() {
    this.setView();
  }

  handleDatasource(type) {
    this.loadingChart = false;
    this.selectedUsersServ.selected_users.subscribe((res) => {
      this.selectedUserDetails = res;
      if (res.length !== 0) {
        const { ids, type: filtertype } = res;
        let query;
        if (type === 'invoice') {
          if (filtertype === 'salesperson') {
            query = `createdBy=${ids.toString()}`
          } else {
            query = `teamId=${ids.toString()}`
          }
          this.invoiceServ.getInvoiceByFilter(query).subscribe((res: any) => {
            const { payload } = res;
            let dataSourceInBaseCurr = this.currencyServ.dataSourceInBase(payload);
            this.dataSource = TOPCLIENTS(dataSourceInBaseCurr, this.format, 'invoice-deals');
            this.loadingChart = true;
            this.dataTable.dataChangedObs.next(true);

          })
        } else {
          if (filtertype === 'salesperson') {
            query = {
              creatorId: { owner: ids.toString() }
            }
            this.dealsServ.fetchDeals(null, query).subscribe((res: any) => {
              let massageData = res.map((rep) => {
                return { ...rep, totalCost: Number(rep.amount) }
              })
              let dataSourceInBaseCurr = this.currencyServ.dataSourceInBase(massageData);
              if (type === 'forecast') {
                this.dataSource = TOPCLIENTS(dataSourceInBaseCurr, this.format, 'deal-forecast');
                this.loadingChart = true;
                this.dataTable.dataChangedObs.next(true);

              } else {
                this.dataSource = TOPCLIENTS(dataSourceInBaseCurr, this.format, 'invoice-deals');
                this.loadingChart = true;
                this.dataTable.dataChangedObs.next(true);
              }
            });
          } else {
            this.dealsServ.fetchDeals(ids).subscribe((res: any) => {
              let massageData = res.map((rep) => {
                return { ...rep, totalCost: Number(rep.amount) }
              });
              let dataSourceInBaseCurr = this.currencyServ.dataSourceInBase(massageData);
              this.dataSource = TOPCLIENTS(dataSourceInBaseCurr, this.format, 'invoice-deals');
              this.loadingChart = true;
              this.dataTable.dataChangedObs.next(true);
            });
          }
        }

      }
    });
  }

  setView() {
    this.handleDatasource(this.viewType);
  }

}
